module.exports = "<span id=natp-myaccount class=\"\"> <div id=myaccount-greeting></div> <div id=myaccount-trigger class=header-trigger> <span><span class=my-prefix>My </span>Account</span> </div> <div class=header-dropdown> <div id=natp-login-myAccountLinks></div> </div> </span>";


//////////////////
// WEBPACK FOOTER
// ./~/html-loader!./src/scripts/components/myAccount/myAccount.html
// module id = 47
// module chunks = 0